import { put, takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import { refetchesAfterFailure } from '@/features/organizations/model/write-outcome';
import * as referralApi from '../api/referral-codes.api';
import {
  createReferralCode,
  fetchReferralCodes,
  fetchReferralRedemptions,
  updateReferralCode,
} from './referral-codes.slice';

const apiSaga = createPanelApiSaga();

/**
 * REFERANS KODU SAGALARI.
 *
 * OKUMA `takeLatest`: art arda tazelemede eski cevap yenisini ezemez. Kenar
 * katmanında hızla başka bir koda geçilirse önceki kodun okuması iptal olur.
 *
 * YAZMALARIN tekilliği DÜĞME KİLİDİNDEN gelir (diyalog gönderim sürerken
 * düğmeler ve alanlar kapalı, `takeLatest` ikinci basışı da yutar). Oluşturma
 * ucunun yineleme anahtarı yoktur, ama ad tekildir: aynı gövde ikinci kez
 * gitse sunucu 409 `REFERRAL_CODE_NAME_TAKEN` döner, ikinci kod yazılmaz.
 *
 * SONUCU BİLİNMEYEN HATADA ve 409'da liste YENİDEN ÇEKİLİR: kod sunucuda
 * yazılmış olabilir, ekran tahmin etmez (`refetchesAfterFailure`).
 */
export function* referralCodesSaga() {
  yield takeLatest(
    fetchReferralCodes.request.type,
    apiSaga(fetchReferralCodes, () => referralApi.fetchAllReferralCodes()),
  );
  yield takeLatest(
    fetchReferralRedemptions.request.type,
    apiSaga(fetchReferralRedemptions, async ({ id }: { id: string }) => ({
      id,
      items: await referralApi.fetchAllReferralRedemptions(id),
    })),
  );
  yield takeLatest(
    createReferralCode.request.type,
    apiSaga(createReferralCode, referralApi.createReferralCode, {
      onSuccess: function* () {
        yield put(fetchReferralCodes.request());
      },
      onFailure: function* (error) {
        if (refetchesAfterFailure(error)) yield put(fetchReferralCodes.request());
      },
    }),
  );
  yield takeLatest(
    updateReferralCode.request.type,
    apiSaga(updateReferralCode, referralApi.updateReferralCode, {
      onSuccess: function* () {
        yield put(fetchReferralCodes.request());
      },
      onFailure: function* (error) {
        if (refetchesAfterFailure(error)) yield put(fetchReferralCodes.request());
      },
    }),
  );
}
